module.exports = __webpack_public_path__ + "static/img/login.fca5c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login.jpg
// module id = DdvY
// module chunks = 1